// popper is causing a scroll to top that keeps creeping up the page after a refresh
// this counteracts that behavior

// On load
document.addEventListener('DOMContentLoaded', () => {

    const scrollPos = sessionStorage.getItem('scrollPos');

    if(scrollPos) {
        window.scrollTo(scrollPos.x, scrollPos.y);
    }

})

// On unload
window.addEventListener('beforeunload', () => {

    sessionStorage.setItem('scrollPos', {
        x: window.scrollX,
        y: window.scrollY
    });

})

// Reset scroll after Popper loads
// document.addEventListener('DOMContentLoaded', () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
// });